export default __webpack_public_path__ + "static/media/Zasway-LogoMain.b56dc3cd.png";